import script from "./BaseCardInstruction.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseCardInstruction.vue?vue&type=script&setup=true&lang=js"

import "./BaseCardInstruction.vue?vue&type=style&index=0&id=f9c5b02a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9c5b02a"]])

export default __exports__